import React, { Component } from 'react';
import { Switch, Spin, Tooltip, Modal, Button, Icon, Pagination, Avatar, notification, Empty } from 'antd';
import { UndoOutlined, CloseOutlined, UserOutlined  } from '@ant-design/icons';
import { CSVLink } from "react-csv";
import moment from 'moment';
//import {trackbills} from '../../schema/bill-tacking';
import {admissionadvises} from '../../schema/admission-advises';
import Select2 from '../../components/FormComponent/select2';
import Select2multiple from '../../components/FormComponent/select2/multiple';
import DateRange from '../../components/FormComponent/DateRange';
import Inputlayer from '../../components/FormComponent/Input';
import { filter, formData, dissableFormData } from '../../schema/apppointment';
// import Pagination from "react-js-pagination";
import networkList from '../../constants/networkList';
import postService from '../../services/httpService';
const { addCounsellorComments, getCounsellorCommentsByPatient, homepage }= networkList

const $ = require('jquery');
let i = 0;

class AdmissionsAdvised extends Component {
    showBillDetails = (ip, latest_counselled_by, latest_estimated_amt) => {
        if (ip != null && latest_counselled_by !== null && latest_estimated_amt !== null) {
            this
                .props
                .history
                .push(`/bill-details`, ip);
        } else {
            // notification.error({
            //     message: 'Failure',
            //     description: 'Oops, something went wrong... Please try again.',
            //     duration: 10,
            //     top: 20,
            //     right: 0
            // });
        }

        // alert(ip)
    }
    csvLink = React.createRef()
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            totalItemsCount: 0,
            downloadStatus: 0,
            'thead': [],
            'tbody': [],
            search_key:'',
            dateTo: moment().format('YYYY-MM-DD'),
            dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            downloadtbody: [],
            commentModal: false,
            comments: null,
            patient_details: {},
            commentsArray: [],
            payer_type:["GENERAL", "INSURANCE"]
        };
    }


    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    componentDidMount() {

        let formSchema = Object.assign({}, admissionadvises);
        formSchema['feilds'].map((feild, key) => {
            if (feild.name === 'doctorid') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Doctor';
            } else if (feild.name === 'departmentbyunit') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Department';
            } else if (feild.name === 'payer_type') {
                formSchema['feilds'][key]['value'] = ["GENERAL", "INSURANCE"];
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = ["GENERAL", "INSURANCE"];
            } else if ( feild.name === 'bill_value') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Bill Value';
            } else if ( feild.name === 'nursestationbyunit') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Nurse Station';
            } else if( feild.name === 'ward_type'){
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Ward Type';
            }else{
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                delete formSchema['feilds'][key]['text'];
            }
            

        })
        this.setState({ activePage: 1, totalItemsCount: 0, 'formData': formSchema['feilds'] }, () => {
            this.loadPage()
        });
    }

    componentWillUnmount() {
        $('footer').css({ 'position': 'relative', top: 'unset' });
        this.setState({ formData: [] });
        localStorage.removeItem("planned_without_estimates");
    }

    loadPage = () => {
        let is_planned_without_estimates = JSON.parse(localStorage.getItem("planned_without_estimates"));
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, doctor_id, department_name, payer_type, bill_value, nurse_station_code, ward_type } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getAdmissionAdvises } = networkList;
            let tableHead = [];
            tableHead = [
                {
                    "key":'umr_no',
                    'label':'UMR'
                },
                {
                    "key":'patient_name',
                    'label':'Patient Name'
                },
                {
                    "key":'patient_phno',
                    'label':'Patient Phone'
                },
                {
                    "key":'patient_age',
                    "label":'Age'
                },
                {
                    "key":'patient_gender',
                    'label':'Gender'
                },
                {
                    "key":'ref_doctor_name',
                    'label':'Ref Doctor Name'
                },
                {
                    "key":'is_admission_advised',
                    'label':'Is Admission Advised'
                },
                {
                    "key":'estimated_admission_date',
                    'label':'Estimated Date Of Admission'
                },
                {
                    "key":'remarks',
                    'label':'Remarks'
                },
                {
                    "key":'created_at',
                    'label':'Advised Date'
                },
                {
                    "key":'updated_at',
                    'label':'Modified Date'
                },
                // {
                //     "key":'is_counselling_done',
                //     'label':'Is Counselling Done'
                // },
                {
                    "key":'unitname',
                    'label': 'Unit Name'
                },
                {
                    "key":'los_wards',
                    'label': 'LOS Wards'
                },
                {
                    "key":'los_icu',
                    'label': 'LOS ICU'
                },
                {
                    "key":'op_investigations',
                    'label': 'OP Investigations'
                },
                {
                    "key":'op_procedures',
                    'label': 'OP Procedures'
                },
                {
                    "key":'implant_cost',
                    'label': 'Implant Cost'
                },
                {
                    "key":'total_estimated_cost',
                    'label': 'Total Estimated Cost'
                },
                {
                    "key":'surgeries',
                    'label': 'Surgeries'
                },
                {
                    "key":'professional_fees',
                    'label': 'Professional Fees'
                },
                {
                    "key":'department_type',
                    'label': 'Care Management'
                }
            ]
            let ward_type_value = ''
            if(ward_type){
                if(ward_type.length>1){
                    ward_type_value = 'all'
                }else{
                    ward_type_value = ward_type[0]
                }
            }else{
                ward_type_value = null
            }
            this.setState((state) => ({ downloadStatus: 0, tbody: [], tableTitle: 'Admissions Advised', thead: tableHead, loadding: true, filename: 'Admission-Advised-Report.csv' }), () => {
                postService(getAdmissionAdvises, 'POST', {
                    "data": {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "search_key": this.state.search ? this.state.search : "",
                        "from": This.state.dateFrom ? moment(this.state.dateFrom).format('YYYY-MM-DD') : '',
                        "to": This.state.dateTo ? moment(this.state.dateTo).format('YYYY-MM-DD') : '',
                    }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        res.data.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                if (dataKey === 'admission_date') {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                }
                                if (dataKey === 'latest_counselled_date') {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                }
                                if(dataKey === 'department_type'){
                                    res.data[key][dataKey] = res.data[key][dataKey] === 'medical_department' ? 'Medical' : 'Surgical'
                                }


                            })
                        })
                        this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data, loadding: false }));
                        // enable downloadbtn after 2sec
                        setTimeout(function () {
                            This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }

    handleChange(ele) {
        console.log(ele);
        var formFeilds = this.state.formData;
        let { search } = this.state
    }
    submit() {
        var formFeilds = this.state.formData;
        let { search } = this.state
        this.setState(({search_key: '',activePage: 1, }), () => {
            this.inputRef.value = null;
            this.loadPage()
        })
    }
    searchChange(e) {
        try {
        console.log(e.target.value);
        let value = e.target.value
        i = 0;
        this.setState((state) => ({
            'search_key': value
        })
        );
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })
    }
    }
    // searchClick() {
    //     this.setState((state) => ({
    //         activePage: 1,
            
    //         tbody: [],
    //         totalItemsCount: 0,
    //         doctor_id: [], 
    //         department_name: [],  
    //         payer_type: [],  
    //         bill_value: [],  
    //         nurse_station_code: [],
    //         ward_type: []
    //     }), () => {
    //         this.loadPage();
    //         var formFeilds = this.state.formData;
    //             formFeilds.map((feild, key) => {
    //                 if (feild.name === 'doctorid') {
    //                     formFeilds[key]['value'] = [];
    //                     formFeilds[key]['valid'] = false;
    //                     formFeilds[key]['errors'] = [];
    //                     formFeilds[key]['text'] = 'Doctor';
    //                 } else if (feild.name === 'departmentbyunit') {
    //                     formFeilds[key]['value'] = [];
    //                     formFeilds[key]['valid'] = false;
    //                     formFeilds[key]['errors'] = [];
    //                     formFeilds[key]['text'] = 'Department';
    //                 } else if (feild.name === 'payer_type') {
    //                     formFeilds[key]['value'] = ["GENERAL", "INSURANCE"];
    //                     formFeilds[key]['valid'] = false;
    //                     formFeilds[key]['errors'] = [];
    //                     formFeilds[key]['text'] = ["GENERAL", "INSURANCE"];
    //                 } else if ( feild.name === 'bill_value') {
    //                     formFeilds[key]['value'] = [];
    //                     formFeilds[key]['valid'] = false;
    //                     formFeilds[key]['errors'] = [];
    //                     formFeilds[key]['text'] = 'Bill Value';
    //                 }else if ( feild.name === 'nursestationbyunit') {
    //                     formFeilds[key]['value'] = [];
    //                     formFeilds[key]['valid'] = false;
    //                     formFeilds[key]['errors'] = [];
    //                     formFeilds[key]['text'] = 'Nurse Station';
    //                 }else if( feild.name === 'ward_type'){
    //                     formFeilds[key]['value'] = [];
    //                     formFeilds[key]['valid'] = false;
    //                     formFeilds[key]['errors'] = [];
    //                     formFeilds[key]['text'] = 'Ward Type';
    //                 }else{
    //                     formFeilds[key]['value'] = [];
    //                     formFeilds[key]['valid'] = false;
    //                     formFeilds[key]['errors'] = [];
    //                     delete formFeilds[key]['text'];
    //                 }
    //             })
    //             this.setState({ formData: formFeilds })
    //     })
    // }    


    searchClick() {
        try {
            let { getAdmissionAdvises } = networkList;
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
        let { page_data_count, search_key, doctor_id, department_name ,pre_auth_submits,insurance_status,fc_payer_type,hims_payer_type} = this.state;
            postService(getAdmissionAdvises, 'POST', {
                'data': {
                    "search_key": search_key,
                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                }
            }).then(res => {
                this.setState((state) => ({ loadding: false }));
                if (res.status) {
                    if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                        this.setState((state) => ({ 'tbody': res['data'], 'total_items': res['total_count'], loadding: false }))
                        // enable downloadbtn after 2sec
                        // setTimeout(function () {
                        //     This.setState((state) => ({ downloadStatus: 1 }))
                        // }, 2000);
                    } else {
                        this.setState((state) => ({ 'tbody': [], 'total_items': 0 }))

                    }
                } else {
                    if (res === 401) {

                    } else {
                        Modal.error({
                            title: 'Failure',
                            content: "Oops! something went wrong... Please try again.",
                        });
                    }

                }
            })


        this.setState((state) => ({
            activePage: 1,
            tbody: [],
            totalItemsCount: 0,
            doctor_id: [],
            department_name: []
        }), () => {
            var formFeilds = this.state.formData;
            formFeilds.map((feild, key) => {
                if (feild.name === 'doctorid') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Doctor';
                } else if (feild.name === 'pendingDocs_departmentbyunit') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Department';
                }
                else if (feild.name === 'pre_auth_submitted') {
                    formFeilds[key]['value'] = null;
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Pre-Auth Submitted';
                }
                else if (feild.name === 'insurance_status') {
                    formFeilds[key]['value'] = null;
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Insurance Status';
                } else {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    delete formFeilds[key]['text'];
                }
            })
            this.setState({ formData: formFeilds })
        })
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })
    }
    }
    handlePageChange(page) {
        console.log(page);
        this.setState((state) => ({
            activePage: page,
            tbody: []
        }), () => {
            this.loadPage();
        })
    }

    dateRange = () => {
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
            page_data_count: 1,
            search_key: ''
        }), () => {
            this.inputRef.value = null;
            this.loadPage();
            //this.renderBody(true);
        })
    }
    downloadFile = () => {
        let is_planned_without_estimates = JSON.parse(localStorage.getItem("planned_without_estimates"));
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, doctor_id, department_name, payer_type, bill_value, nurse_station_code, ward_type } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getAdmissionAdvises } = networkList;
            let tableHead = [];
            tableHead = [
                {
                    "key":'umr_no',
                    'label':'UMR'
                },
                {
                    "key":'patient_name',
                    'label':'Patient Name'
                },
                {
                    "key":'patient_phno',
                    'label':'Patient Phone'
                },
                {
                    "key":'patient_age',
                    "label":'Age'
                },
                {
                    "key":'patient_gender',
                    'label':'Gender'
                },
                {
                    "key":'ref_doctor_name',
                    'label':'Ref Doctor Name'
                },
                {
                    "key":'is_admission_advised',
                    'label':'Is Admission Advised'
                },
                {
                    "key":'estimated_admission_date',
                    'label':'Estimated Date Of Admission'
                },
                {
                    "key":'remarks',
                    'label':'Remarks'
                },
                {
                    "key":'created_at',
                    'label':'Advised Date'
                },
                {
                    "key":'updated_at',
                    'label':'Modified Date'
                },
                // {
                //     "key":'is_counselling_done',
                //     'label':'Is Counselling Done'
                // },
                {
                    "key":'unitname',
                    'label': 'Unit Name'
                },
                {
                    "key":'los_wards',
                    'label': 'LOS Wards'
                },
                {
                    "key":'los_icu',
                    'label': 'LOS ICU'
                },
                {
                    "key":'op_investigations',
                    'label': 'OP Investigations'
                },
                {
                    "key":'op_procedures',
                    'label': 'OP Procedures'
                },
                {
                    "key":'implant_cost',
                    'label': 'Implant Cost'
                },
                {
                    "key":'total_estimated_cost',
                    'label': 'Total Estimated Cost'
                },
                {
                    "key":'surgeries',
                    'label': 'Surgeries'
                },
                {
                    "key":'professional_fees',
                    'label': 'Professional Fees'
                },
                {
                    "key":'department_type',
                    'label': 'Care Management'
                }
            ]
            let ward_type_value = ''
            if(ward_type){
                if(ward_type.length>1){
                    ward_type_value = 'all'
                }else{
                    ward_type_value = ward_type[0]
                }
            }else{
                ward_type_value = null
            }
            This.setState((state) => ({ downloadStatus: 0, thead: tableHead, loadding: true, filename: 'Admission-Advised-Report.csv' }), () => {
                postService(getAdmissionAdvises, 'POST', {
                    // "data": {
                    //     "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    //     "search_key": This.state.search ? This.state.search : "",
                    //     "counselled_by_id": null,
                    //     "export": 1, //1 for download excel
                    //     "page_no": 0,
                    //     "doctor_id": doctor_id ? doctor_id : [],
                    //     "department_name": department_name ? department_name : [],
                    //     "payer_type": payer_type ? payer_type : [],
                    //     "bill_value": bill_value ? bill_value : [],
                    //     "nurse_station_code": nurse_station_code ? nurse_station_code : [],
                    //     "ward_type": ward_type_value,
                    //     "planned_without_estimates" : is_planned_without_estimates ? is_planned_without_estimates : false
                    // }
                    "data": {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "search_key": this.state.search ? this.state.search : "",
                        "from": This.state.dateFrom ? moment(this.state.dateFrom).format('YYYY-MM-DD') : '',
                        "to": This.state.dateTo ? moment(this.state.dateTo).format('YYYY-MM-DD') : '',
                    }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        res.data.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                if (dataKey === 'admission_date') {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                }
                                if (dataKey === 'latest_counselled_date') {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
                                }
                                if(dataKey === 'department_type'){
                                    res.data[key][dataKey] = res.data[key][dataKey] === 'medical_department' ? 'Medical' : 'Surgical'
                                }
                                else {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? res.data[key][dataKey] : 'NA'
                                }

                            })
                        })
                        This.setState((state) => ({ downloadtbody: res.data, loadding: false, downloadStatus: 1 }));
                        this.csvLink.current.link.click();
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }
    clearFilter = () => {
        this.setState(() => ({ doctor_id: '', department_name: '', payer_type: '', bill_value: '', nurse_station_code: '',ward_type: '', search: '', activePage: 1, totalItemsCount: 0 }),
            () => {
                this.inputRef.value = null;
                var formFeilds = this.state.formData;
                formFeilds.map((feild, key) => {
                    if (feild.name === 'doctorid') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Doctor';
                    } else if (feild.name === 'departmentbyunit') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Department';
                    } else if (feild.name === 'payer_type') {
                        formFeilds[key]['value'] = ["GENERAL", "INSURANCE"];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = ["GENERAL", "INSURANCE"];
                    } else if ( feild.name === 'bill_value') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Bill Value';
                    } else if ( feild.name === 'nursestationbyunit') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Nurse Station';
                    } else if( feild.name === 'ward_type'){
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Ward Type';
                    }else{
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        delete formFeilds[key]['text'];
                    }
                })
                this.setState({ formData: formFeilds,dateTo: moment().format('YYYY-MM-DD'),
                dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD') })
                this.loadPage();
            })

    }

    commentsModal = (data) => {
        let This = this
        let user_data 
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        try{
        This.setState((state) => ({  commentModal: true, patient_details: data, loadding: true }), () => {
            postService(getCounsellorCommentsByPatient, 'POST', {
                "data":{
                    "unit_id": user_data['unitid'] ? user_data['unitid'] : null,
                    "ip_no": data.ip_no ? data.ip_no : null
                }
            }).then(res => {
                console.log('comments:', res);                
                if (res.status) {                    
                    This.setState((state) => ({ 'loadding': false, 'commentsArray': res['data']}));                    
                } else {
                    This.setState((state) => ({ 'loadding': false, 'commentsArray': [] }));
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                        zIndex: 1022
                    });
                }
            });
        });
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Failure',
            content: "Oops, something went wrong... Please try again.",
            zIndex: 1022
        });
    }        
    }

    comments(event) {
        let value = event.target.value;
        this.setState((state) => ({ 'comments': value ? value : null }));
    }

    submitCommint=()=>{
        let{comments, patient_details}=this.state
        let This = this
        let user_data 
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        if(comments && comments.length>12){
            try{
                This.setState((state) => ({ loadding: true }), () => {
                    postService(addCounsellorComments, 'POST', {
                        "data":{
                            "ip_no": patient_details.ip_no ? patient_details.ip_no : null,
                            "unit_id": user_data['unitid'] ? user_data['unitid'] : null,
                            "comment": comments,
                            "comment_from": "admissionadvises",   // due or trackbills
                            "doctor_id":patient_details.doctor_id?patient_details.doctor_id:null,
                             "is_iccu":patient_details.is_iccu?patient_details.is_iccu:null
        

                        }
                    }).then(res => {
                        console.log('comments:', res);                
                        if (res.status) {                
                            Modal.success({
                                title: 'Success',
                                content: res.message ? res.message : "Success",
                                zIndex: 1022
                            });    
                            This.setState((state) => ({ 'loadding': false, comments: null }));
                            This.commentsModal(patient_details)                    
                        } else {
                            This.setState((state) => ({ 'loadding': false }));
                            Modal.error({
                                title: 'Failure',
                                content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                                zIndex: 1022
                            });
                        }
                    });
                });
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Failure',
                    content: "Oops, something went wrong... Please try again.",
                });
            }        
        }else{
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Failure',
                content: 'Please enter comment briefly.',
                zIndex: 1022
            })
        }
    }
    render() {
        let { tableTitle, thead, activePage, tbody, downloadtbody, filename, formData, totalItemsCount, downloadStatus, commentModal, comments, patient_details, commentsArray, loadding } = this.state;
        return (
            <div>               
                <div className="clearfix mx-5">
                <div className="float-left pt-2">
                {tableTitle}
                </div>
                {
                         downloadStatus && tbody != ''
                            ?
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">                                
                                <button className="btn btn-success text-capitalize" onClick={() => { this.downloadFile() }}><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Worklist</span></button>
                                <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />                                
                                <button className="btn btn-light text-capitalize py-1 mr-3" onClick={() => { this.clearFilter() }}><UndoOutlined  className="align-middle pr-2" /><span> Clear</span></button>
                                {/* <button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit()}}><span>Submit</span></button> */}
                            </div>
                            :
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                <Button className="btn btn-success-disabled text-capitalize" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Worklist</span></Button>
                                <button className="btn btn-light text-capitalize py-1 mr-3 " onClick={() => { this.clearFilter() }}><UndoOutlined  type="reload" className="align-middle pr-2" /><span> Clear</span></button>                                    
                                {/* <Button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit()}}><span>Submit</span></Button> */}
                            </div>
                }
                </div>

                <Spin spinning={loadding}>
                    <div className="card ml-5 mr-5 mb-5 card-table">
                        <div className="card-header bg8">
                            <div className="clearfix">
                                <div className="row">
                                    {(formData !== undefined) && <React.Fragment>

                                        {formData
                                            .map((feild, key) => {

                                                if (feild.element === 'input') {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                            <div className="input-group" key={key}>
                                                                <div
                                                                    className='w-100'
                                                                    key={key}>
                                                                     <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR" onBlur={this.searchChange.bind(this)} ref={(inputRef =>(this.inputRef = inputRef))} />
                                                    <div class="input-group-append" style={{position: 'absolute', right: 0, height: '32px', top: 0}}>
                                                        <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                if (feild.element === 'daterange') {
                                                    return (
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} ${feild.name}`}
                                                            key={key}>
                                                            {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}
    
                                                            <DateRange
                                                                Queuedata={formData}
                                                                selectdata={feild}
                                                                {...this.props}
                                                                {...this.state}
                                                                onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] }) }}
                                                            />
                                                            <div class="input-group-append">
                                                                <button class="btn btn-primary btn-sm ml-1" onClick={this.dateRange}>Go</button>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })}

                                    </React.Fragment>}
                                </div>
                            </div>
                        </div>
                        <div className="financial-table table-responsive sticky-header" id="table">
                            <table className="table table-hover table-bordered mb-0 admission-advised bg-white">
                                <thead>
                                    <tr>
                                        <td className="text-capitalize align-middle">s.no.</td>
                                        {thead.map((head, key) => {
                                            if(head['label']==='Trigger  Status'){
                                                return (<td className="text-capitalize align-middle" key={key} style={{width:'10%'}}>{head['label']}</td>)
                                            }else{
                                                return (<td className="text-capitalize align-middle" key={key}>{head['label']}</td>)
                                            }
                                            
                                        })}
                                    </tr>
                                </thead>
                                {
                                    tbody != ''
                                        ?
                                        <tbody>
                                            {tbody.map((body, key) => {
                                                return (<tr key={key} style={(body.ip_no != null && body.latest_counselled_by !== null && body.latest_estimated_amt !== null) ? { 'cursor': 'pointer', 'backgroundColor': '#ffeeba' } : { 'cursor': 'default' }}>
                                                    <td  onClick={this.showBillDetails.bind(this, body.ip_no, body.latest_counselled_by, body.latest_estimated_amt)}>{(key + 1) + (activePage > 1 ? 20 * (activePage > 2 ? (activePage - 1) : 1) : 0)}</td>
                                                    {thead.map((head, Hkey) => {
                                                        return (<td key={Hkey} className="text-capitalize"  onClick={this.showBillDetails.bind(this, body.ip_no, body.latest_counselled_by, body.latest_estimated_amt)}>{body[head['key']] ? body[head['key']] : 'NA'}</td>);
                                                    })
                                                    }
                                                </tr>)
                                            })}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                    <p className="no-data mb-0">No Data</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                }
                            </table>
                        </div>

                    </div>
                    <div className="row justify-content-center align-item-center mx-0">
                        <div className="col pagenation-col mb-3">
                            <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={20} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />

                        </div>
                    </div>
                    
                </Spin>
            </div>
        )
    }
}

export default AdmissionsAdvised;